import { Kits } from "../modules/kits";

export const KitsPage = () => {
  return <Kits />;
};
